import styled from '@emotion/styled'
import Link from 'next/link'
import { mq } from '../../../helpers'

export const PressGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 17px;
  padding: 0 88px 60px;

  ${mq('max', '1024px')} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  ${mq('max', '768px')} {
    grid-template-columns: 1fr;
    padding: 0 16px 40px;
  }
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f9f6f1;
  box-sizing: border-box;
  ${(props) =>
    props.featured &&
    `
    grid-column: 1 / -1;
    flex-direction: row;
    min-height: 355px;

    ${mq('max', '768px')} {
      flex-direction: column;
      min-height: 0;
    }
  `}
`

export const CardImage = styled.div`
  position: relative;
  aspect-ratio: 16 / 9;
  ${(props) =>
    props.featured &&
    `
    ${mq('min', '769px')} {
      flex: 1 1 50%;
      aspect-ratio: auto;
      align-self: stretch;
    }
  `}
`

export const CardBody = styled.div`
  padding: 20px;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  ${(props) =>
    props.featured &&
    `
    ${mq('min', '769px')} {
      flex: 1 1 50%;
      justify-content: center;
      padding: 60px 55px;
    }
  `}
`

export const PublicationLogo = styled.div`
  position: relative;
  height: 28px;
  width: 120px;
  img {
    object-fit: contain;
    object-position: left center;
  }
`

export const PressTitle = styled.h3`
  color: var(--Black, #000);
  font-family: Garnett;
  font-size: 20px;
  font-weight: 750;
  line-height: 140%;
  letter-spacing: 0.282px;
  margin: 0;
  ${(props) =>
    props.featured &&
    `
    font-size: 36px;
    ${mq('max', '768px')} {
      font-size: 24px;
    }
  `}
`

export const ReadMore = styled(Link)`
  color: var(--Blue, #07218F);
  font-family: Euclid;
  font-size: 16px;
  font-weight: 600;
  line-height: 145%;
  letter-spacing: 0.16px;
  text-decoration: none;
  width: fit-content;
  margin-top: auto;
`

export const ReadMoreButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 32px;
  margin-top: 4px;
  border: 1px solid var(--Blue, #07218F);
  color: var(--Blue, #07218F);
  font-family: Euclid;
  font-size: 16px;
  font-weight: 600;
  line-height: 145%;
  letter-spacing: 0.16px;
  text-decoration: none;
  width: fit-content;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    background-color: var(--Blue, #07218F);
    color: #fff;
  }
`
